/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Reset_Link_Sent_TitleInputs */

const en_common_sign_reset_link_sent_title = /** @type {(inputs: Common_Sign_Reset_Link_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const zh_common_sign_reset_link_sent_title = /** @type {(inputs: Common_Sign_Reset_Link_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请查收邮件`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Common_Sign_Reset_Link_Sent_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_link_sent_title = /** @type {((inputs?: Common_Sign_Reset_Link_Sent_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Link_Sent_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_reset_link_sent_title(inputs)
	return zh_common_sign_reset_link_sent_title(inputs)
});
export { common_sign_reset_link_sent_title as "common.sign.reset_link_sent_title" }